import styled, { css } from "styled-components";

import { COLORS, SHADOW } from "@treelab/panda";

export const Container = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 100;
`;

export const Mask = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  padding: 14px 16px 16px 24px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  width: 272px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: ${SHADOW.overlay1};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > button {
    background-color: #ffffff;
    border: none;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.greyDark1};
`;

export const CloseBtn = styled.div``;

export const Message = styled.div`
  margin-top: 12px;
  font-size: 14px;
  line-height: 24px;
  color: #292d3d;
`;

export const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  & > *:first-child {
    margin-right: 16px;
    background-color: #ffffff;
  }
`;
